import { useWorldStore } from '../state/worldStore';
import { IS_GUEST } from '../config';

// useRideGate — is Spor1's ride the open errand, right now?
//
// THE STORY STARTS WITH LYRA'S CALL (Khari, 2026-08-05: "Don't initiate the
// game and the dialogue until I have answered Lyra's call and 'accepted the
// mission'"). Spor1 is the first person you have to talk to, which makes him
// the easiest thing in the world to trigger by accident — walk past him on
// spawn and the game has begun without its opening.
//
// Guests were always gated correctly (`arrivalDone`), because a guest's story
// state IS the client ledger. MEMBERS were not: three surfaces each asked only
// whether `come_up_the_ride` was open, and never whether Act 0 had happened.
// That is not the same question — a returning artist can have the ride quest
// available at spawn (M8 seeds beats from an existing profile), so the beacon
// lit, the errand chip showed and tapping him boarded, all before she rang.
//
// One rule, one place. The three surfaces that show or start the ride —
// Spor1Lotus (the beacon), RideOverlay (the kerb card) and AvatarChatDock (the
// tap) — read this, so they can never drift apart again.
//
// Truth comes from `phoneQuests`: the shared snapshot the Phone publishes and
// refreshes. A component's own useQuestChain would go stale the moment the
// call it is waiting for completes.
export function useRideGate() {
  const phoneQuests = useWorldStore((s) => s.phoneQuests);
  const guestProgress = useWorldStore((s) => s.guestProgress);
  const myAvatarId = useWorldStore((s) => s.myAvatarId);

  if (IS_GUEST) {
    const arrivalDone = !!guestProgress?.arrivalDone;
    return { arrivalDone, rideOpen: arrivalDone && !guestProgress?.rideDone };
  }

  const list = phoneQuests || [];
  const open = (slug) => list.some((q) => q.slug === slug
    && (q.status === 'available' || q.status === 'active'));

  // A completed quest is filtered out server-side, so "still listed as
  // available/active" is the only honest test for pending. If the list has not
  // arrived yet it is empty — every gate reads CLOSED, which is the right way
  // to fail for something whose whole job is to not start too early.
  const arrivalDone = list.length > 0 && !open('come_up_arrival');

  return { arrivalDone, rideOpen: arrivalDone && open('come_up_the_ride') && !!myAvatarId };
}

export default useRideGate;
